import { render } from "./App.vue?vue&type=template&id=5e5491ee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5e5491ee&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__